import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { CustomersComponent } from '../customers/customers.component';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { TableDataComponent } from '../table-data/table-data.component';
import { TagsComponent } from '@enginuity/core/molecules/tags/tags.component';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { IconBtnComponent } from '@enginuity/core/molecules/icon-btn/icon-btn.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-overlay-value-data',
  templateUrl: './overlay-value-data.component.html',
  styleUrls: ['./overlay-value-data.component.scss'],
  imports: [
    CommonModule,
    CeIconComponent,
    CustomersComponent,
    BadgesComponent,
    DropdownComponent,
    TableDataComponent,
    TagsComponent,
    ActionBtnComponent,
    OverlayModule,
    MatTooltipModule,
    IconBtnComponent,
  ],
})
export class OverlayValueDataComponent implements OnInit, OnChanges {
  @Input() title: string = '';
  @Input() text = false;
  @Input() copy: boolean = false;
  @Input() link: boolean = false;
  @Input() title_icon: string = '';
  @Input() readOnly = false;
  @Input() space = false;
  @Input() emptyskeletonLabel = 'select';
  @Input() tooltipText = '';
  @Input() linkIcon = 'external';
  @Input() valueType: string | 'customer' | 'status' | 'tags' | 'text' = 'status';
  @Input() isDropdown: boolean = true;
  @Output() onCopy = new EventEmitter();
  @Output() onClick = new EventEmitter();
  isOpen = false;
  onStatus() {
    this.isOpen = !this.isOpen;
  }
  iconName: string = 'jam_files_f';
  copyUrl() {
    this.onCopy.emit();
    this.iconName = 'check';
    setTimeout(() => {
      this.iconName = 'jam_files_f';
    }, 1000);
  }
  @Input()
  valueOptions: any[] = [
    {
      label: 'completed',
      Type: 'completed',
      withIcon: true,
      IconType: 'dot',
    },
    {
      label: 'pending',
      Type: 'draft',
      withIcon: true,
      IconType: 'dot',
    },
  ];

  @Input()
  currentValue: any | null = null;

  @Input()
  defaultValue = '';

  ngOnInit(): void {
    // this.checkCurrentValue();
  }
  checkCurrentValue() {
    // Update copy based on currentValue being non-null and non-empty
    if (this.currentValue === null || this.currentValue === '' || this.currentValue === undefined) {
      this.copy = true;
    } else {
      this.copy = false;
    }
  }

  ngOnChanges(changes: any) {
    if (
      changes.defaultValue?.currentValue &&
      changes.defaultValue?.currentValue != changes.defaultValue?.previousValue
    ) {
      if (this.valueOptions) {
        for (const item of this.valueOptions) {
          if (
            item?.label?.toLowerCase() == this.defaultValue?.toLowerCase() ||
            item?.name?.toLowerCase() == this.defaultValue?.toLowerCase()
          ) {
            this.currentValue = item;
            break;
          }
        }
      }
    }
  }

  onSelectionChanged(selectedValue: string) {
    console.log(selectedValue);
  }

  setCurrentValue(value: any) {
    this.currentValue = value;
    this.isOpen = false;
  }
  onLinkClick() {
    this.onClick.emit();
  }
}
